import { resolve } from '$app/paths';
import GitHubIcon from '$comp/icons/GitHubIcon.svelte';
import { apiReferenceHref, documentationHref, githubRepositoryHref, supportIssuesHref } from '$features/shared/help-links';
import { appKeyboardShortcuts } from '$features/shared/keyboard-shortcuts';
import Documentation from '@lucide/svelte/icons/book-open';
import Exie from '@lucide/svelte/icons/bot';
import ApiDocumentations from '@lucide/svelte/icons/braces';
import Events from '@lucide/svelte/icons/calendar-days';
import Support from '@lucide/svelte/icons/circle-help';
import Stacks from '@lucide/svelte/icons/layers';
import Sessions from '@lucide/svelte/icons/timer';

import type { NavigationItem } from '../routes.svelte';

import { routes as accountRoutes } from './account/routes.svelte';
import { routes as eventRoutes } from './event/routes.svelte';
import { routes as organizationRoutes } from './organization/routes.svelte';
import { routes as projectRoutes } from './project/routes.svelte';
import { routes as systemRoutes } from './system/routes.svelte';

export function routes(): NavigationItem[] {
    const items = [
        {
            group: 'Dashboards',
            href: resolve('/(app)/stack'),
            icon: Stacks,
            shortcut: appKeyboardShortcuts.stacks.keys,
            title: 'Stacks'
        },
        {
            group: 'Dashboards',
            href: resolve('/(app)/event'),
            icon: Events,
            shortcut: appKeyboardShortcuts.allEvents.keys,
            title: 'Events'
        },
        {
            group: 'Dashboards',
            href: resolve('/(app)/sessions'),
            icon: Sessions,
            title: 'Sessions'
        },
        {
            group: 'Dashboards',
            href: resolve('/(app)/exie'),
            icon: Exie,
            keywords: ['AI', 'assistant', 'chat'],
            title: 'Exie'
        },
        {
            group: 'Help',
            href: documentationHref,
            icon: Documentation,
            openInNewTab: true,
            title: 'Documentation'
        },
        {
            group: 'Help',
            href: supportIssuesHref,
            icon: Support,
            openInNewTab: true,
            title: 'Support'
        },
        {
            group: 'Help',
            href: githubRepositoryHref,
            icon: GitHubIcon,
            openInNewTab: true,
            title: 'GitHub'
        },
        {
            group: 'Help',
            href: apiReferenceHref,
            icon: ApiDocumentations,
            keywords: ['OpenAPI', 'Swagger', 'API Reference'],
            openInNewTab: true,
            title: 'API'
        },
        ...accountRoutes(),
        ...eventRoutes(),
        ...organizationRoutes(),
        ...projectRoutes(),
        ...systemRoutes()
    ];

    return items;
}
